.cf-section-shell {
  padding-bottom: 0;
  position: relative;
}

.cf-section-shell--bordered::after {
  background: var(--color-border-light-next);
  bottom: 0;
  content: '';
  height: 1px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 100vw;
}

.cf-section-shell .pt-lg {
  padding-top: var(--size14);
}

.cf-section-shell .pb-lg {
  padding-bottom: var(--size14);
}

@media screen and (width >= 64rem) {
  .cf-section-shell .pt-lg {
    padding-top: var(--size24);
  }

  .cf-section-shell .pb-lg {
    padding-bottom: var(--size24);
  }
}

@media screen and (width < 900px) {
  .cf-section-shell .mobile-pt-0 {
    padding-top: 0;
  }
}
